import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import {
  BackInStockProductSchema,
  ProductNotificationGroupBy,
  ProductNotificationStatus,
} from "@redotech/redo-model/customer-product-notification/customer-product-notification";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getBackInStockProducts = {
  name: "getBackInStockProducts" as const,
  input: z.object({
    searchQuery: z.string().optional(),
    limit: z.number().int().positive().max(200).default(50),
    groupBy: createEnum(ProductNotificationGroupBy).default(
      ProductNotificationGroupBy.VARIANT,
    ),
    dateFrom: z.date().optional(),
    dateTo: z.date().optional(),
    channels: z.array(createEnum(MarketingChannel)).optional(),
    statuses: z.array(createEnum(ProductNotificationStatus)).optional(),
  }),
  output: z.object({
    products: z.array(BackInStockProductSchema),
    totalCount: z.number(),
  }),
};
